<ion-header class="ion-no-border">
  <ion-toolbar class="ion-no-border"> </ion-toolbar>
</ion-header>
<ion-content color="light">
  <ion-grid [fixed]="true">
    <ion-row>
      <ion-col size="12">
        <div *ngIf="!(completed === true); else completedComp" class="main-wrapper ion-text-center">
          <h2><strong>Validación de datos</strong></h2>
          <p *ngIf="_validatePerEmail === true">
            Por favor, ingrese el código de verificación enviado a su correo electrónico: <strong>{{email}}</strong>
          </p>
          <p *ngIf="_validatePerEmail !== true">
            Por favor ingrese el código de verificación enviado al <strong>{{displayPhone}}</strong>
          </p>
          <code-input [initialFocusField]="0" [isCodeHidden]="false" [codeLength]="6"
            (codeChanged)="onCodeChanged($event)">
          </code-input>
          <br />
          <br />
          <br />
          <ion-button (click)="codeVerification()" color="secondary" expand="block"
            [disabled]="!(code && code.length == 6) || isLoading === true">
            Continuar
          </ion-button>
          <ion-button class="ion-text-wrap ion-no-padding" (click)="optionsAlert()" color="medium" fill="clear"
            shape="round" expand="block" *ngIf="!cooldown.isActive(); else noButton1">
            <p class="ion-text-left">
              ¿No recibió el código?
              <ion-text color="primary"><strong>&nbsp;Cambiar de método&nbsp;</strong></ion-text>
              de verificación o
              <ion-text color="primary"><strong>&nbsp;Reenviar código</strong></ion-text>
            </p>
          </ion-button>
          <ng-template #noButton1>
            <ion-text color="medium">
              <p>Reintentar en {{ cooldown.isActive() ? (cooldown.remainingSeconds* 1000 | date : "mm:ss" ): '0:00' }}
              </p>
            </ion-text>
          </ng-template>
          <br />
          <div *ngIf="attempts >= nAttempts">
            <br>
            <ion-text color="tertiary" expand="block" fill="clear">
              <strong> ¿Tiene problemas para recibir el código?</strong> <br> Contáctenos vía WhatsApp y con gusto le
              atenderemos
            </ion-text>
            <ion-button (click)="whatsAppAlert()" expand="block" color="warning" shape="round">
              <strong>Contactar a Atención a Usuarios</strong>
            </ion-button>
          </div>
        </div>
        <ng-template #completedComp>
          <div class="main-wrapper ion-text-center">
            <ion-text color="secondary">
              <h2>¡Cuenta verificada correctamente!</h2>
              <br />
              <ion-icon name="checkmark-circle-outline" color="success" size="large"></ion-icon>
            </ion-text>
          </div>
        </ng-template>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>